import React from 'react';
import { useLocation } from 'react-router-dom';
import lazyWithRetry from '../../utils/lazyWithRetry';

export const TermsOfServicePage = lazyWithRetry(() => import('../../pages/TermsOfServicePage'));
export const PrivacyPolicyPage = lazyWithRetry(() => import('../../pages/PrivacyPolicyPage'));
export const BusinessAssociateAgreementPage = lazyWithRetry(
  () => import('../../pages/BusinessAssociateAgreementPage'),
);
export const SignupConsentPage = lazyWithRetry(() => import('../../pages/SignupConsentPage'));

/**
 * Routes available to users who still need to complete signup consent.
 * Allows access to /terms, /privacy, /business-associate-agreement, and /baa
 * so users can read the documents they are being asked to accept, while showing
 * the consent page for all other paths.
 */
export function ConsentGateRoutes() {
  const location = useLocation();
  const path = location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/terms') return <TermsOfServicePage />;
  if (path === '/privacy') return <PrivacyPolicyPage />;
  if (path === '/business-associate-agreement') return <BusinessAssociateAgreementPage />;
  if (path === '/baa') return <BusinessAssociateAgreementPage />;
  return <SignupConsentPage />;
}
